<template>
    <div class="login">
        <!-- 顶部栏：语言切换 -->
        <div class="top-bar">
            <mu-menu cover :open.sync="isMenuOpen">
                <mu-button flat small class="lang-btn">
                    <mu-icon value="language" style="margin-right:4px;"></mu-icon>
                    {{ getLanage() }}
                </mu-button>
                <mu-list slot="content">
                    <mu-list-item button @click="selectLanage('DK')">
                        <mu-list-item-title>DK</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('EN')">
                        <mu-list-item-title>EN</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('PT')">
                        <mu-list-item-title>PT</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="selectLanage('中文')">
                        <mu-list-item-title>中文</mu-list-item-title>
                    </mu-list-item>
                </mu-list>
            </mu-menu>
        </div>

        <div class="indexLogin">
            <!-- Logo 区域：自适应各种形状 -->
            <div class="logo-wrap" v-if="seller.logo">
                <div class="logo-frame" :class="logoShape">
                    <img :src="getImgUrl(seller.logo)" alt="logo" class="logo-img" />
                </div>
            </div>
            <div v-else class="restaurant-name">
                {{ seller.restaurantName }}
            </div>

            <mu-form ref="form" :model="tableOrderInfo" class="login-form">
                <mu-form-item :label="$t('login.name')" prop="name" :rules="usernameRules" label-float>
                    <mu-text-field v-model="tableOrderInfo.name" prop="name" autocomplete="name"></mu-text-field>
                </mu-form-item>

                <mu-form-item :label="$t('login.telephone')" prop="telephone" :rules="phoneRules" label-float>
                    <mu-text-field v-model="tableOrderInfo.telephone" prop="telephone" @input="formatPhone"
                        autocomplete="tel"></mu-text-field>
                </mu-form-item>

                <mu-form-item class="sms-row">
                    <mu-checkbox v-model="chkSendSms" value="1" :label="$t('login.accepetSendMsg')"></mu-checkbox>
                </mu-form-item>

                <mu-form-item class="action-buttons">
                    <mu-button color="primary" large full-width @click="enterOrder" class="btn-primary">
                        {{ $t('login.begin') }}
                    </mu-button>
                    <mu-button large full-width @click="anonymousEnter"
                        v-if="tableOrderInfo.orderType != 2" class="btn-secondary">
                        {{ $t('login.anonymous') }}
                    </mu-button>
                </mu-form-item>
            </mu-form>
        </div>
    </div>
</template>

<script>
import { formatDate } from '../utils/formatDate'
import preventBack from 'vue-prevent-browser-back';
export default {
    mixins: [preventBack],//注入  阻止返回上一页
    data() {
        return {

            seller: {},
            logoShape: 'auto', // auto / square / landscape / portrait / wide / tall
            configsData: {},
            chkSendSms: true,
            chkTxt: "Agree to send SMS",
            isMenuOpen: false,
            tableOrderInfo: {
                name: '',
                tableName: '',
                orderType: 1,
                restaurantId: 0,
                telephone: '',
                number: 1,
                specielle: '',
                isSendSms: 1
            },
            options: [
                '1', '2', '3', '4',
                '5', '6', '7', '8',
                '9', '10', '11', '12', '13', '14',
                '15', '16', '17', '18',
                '19', '20'
            ],
            fullscreen: false,
        }
    },
    computed: {
        usernameRules() {
            return [{
                validate: (val) => !!val,
                message: this.$t("login.nameNotNull")
            }];
        },
        phoneRules() {
            return [{
                validate: (val) => !!val,
                message: this.$t("login.phoneNotNull")
            }];
        },
    },
    created() {

    },
    mounted() {
        if (this.$route.query.jumpPath != undefined && this.$route.query.jumpPath != null) {
            this.tableOrderInfo = {
                name: "guest",
                telephone: "00000000",
                tableName: "01",
                restaurantId: this.$route.query.restaurantId,
                currentMenuId: this.$route.query.currentMenuId,
                subMenuId: this.$route.query.subMenuId,
            };
            this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo, 7200000);
            localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
            this.$get('QRCodeBasicInfo/GetRestaurant', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        let data = response.data;
                        this.seller = data;
                        localStorage.setItem('lang', this.seller.language);
                        this.getLanage();
                        localStorage.setItem('seller', JSON.stringify(this.seller));
                        this.$router.push({
                            path: "/" + this.$route.query.jumpPath,
                            query: { restaurantId: this.$route.query.restaurantId, v: Math.random() }
                        })
                    }
                })
            return;
        }
        this.tableOrderInfo.restaurantId = this.$route.query.restaurantId;
        this.tableOrderInfo.tableName = this.$route.query.tableName;
        this.tableOrderInfo.orderType = this.$route.query.type;
        if (this.tableOrderInfo.restaurantId == undefined || this.tableOrderInfo.restaurantId == null || this.tableOrderInfo.restaurantId == 0) {
            this.$router.push({
                path: '/error',
                query: {}
            })
        }
        if (this.tableOrderInfo.orderType != 2) {
            if (this.tableOrderInfo.tableName == undefined || this.tableOrderInfo.tableName == null || this.tableOrderInfo.tableName == '') {
                this.$router.push({
                    path: '/error',
                    query: {}
                })
            }
        }
        if (this.tableOrderInfo.orderType == undefined || this.tableOrderInfo.orderType == null || this.tableOrderInfo.orderType == '') {
            this.$router.push({
                path: '/error',
                query: {}
            })
        }
        this.getRestaurantInfo();

    },
    methods: {
        async getConfigs() {
            await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        response.data.forEach((item) => {
                            this.configsData[item.configKey] = item.configValue;
                        })
                        this.chkTxt = this.configsData.SendSMSTip;
                        if (this.configsData.RequireLogin == '0') {
                            this.tableOrderInfo.name = 'guest';
                            this.tableOrderInfo.telephone = '00000000';
                            this.enterOrder();
                        }
                    }
                });
        },
        // 根据图片宽高比判断形状，自动选择最合适的展示容器
        detectLogoShape(src) {
            let img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                const w = img.naturalWidth;
                const h = img.naturalHeight;
                if (!w || !h) { this.logoShape = 'auto'; return; }
                const ratio = w / h;
                if (Math.abs(ratio - 1) < 0.15) {
                    // 接近正方形
                    this.logoShape = 'square';
                } else if (ratio >= 2.2) {
                    // 超宽横条（如长条文字 logo）
                    this.logoShape = 'wide';
                } else if (ratio <= 0.45) {
                    // 超窄竖条
                    this.logoShape = 'tall';
                } else if (ratio > 1) {
                    // 普通横向
                    this.logoShape = 'landscape';
                } else {
                    // 普通纵向
                    this.logoShape = 'portrait';
                }
            };
            img.onerror = () => { this.logoShape = 'auto'; };
            img.src = src;
        },
        getRestaurantInfo() {
            let param = {
                restaurantId: this.tableOrderInfo.restaurantId
            };
            this.$get('QRCodeBasicInfo/GetRestaurant', param)
                .then(response => {
                    if (response.code == 200) {
                        let data = response.data;
                        this.seller = data;
                        this.getConfigs();
                        // 图片加载后判断形状，设置容器样式
                        this.detectLogoShape(this.getImgUrl(data.logo));
                        localStorage.setItem('lang', this.seller.language);
                        this.getLanage();
                        localStorage.setItem('seller', JSON.stringify(this.seller));
                        this.getTableOrderInfo();
                    } else {
                        this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                    }
                });
        },
        getLanage() {
            if (localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != null) {
                this.$i18n.locale = localStorage.getItem('lang');
                return localStorage.getItem('lang');
            }
            this.$i18n.locale = this.seller.language;
            return this.seller.language;
        },
        selectLanage(lng) {
            this.$i18n.locale = lng;
            localStorage.setItem('lang', lng);
            this.isMenuOpen = false;
        },
        getImgUrl(image) {
            if (image == undefined || image == 'undefined') {
                return null;
            }
            return this.imageBaseUrl + image;
        },
        anonymousEnter() {
            this.tableOrderInfo.name = 'guest';
            this.tableOrderInfo.telephone = '00000000';
            this.enterOrder();
        },
        enterOrder() {
            this.tableOrderInfo.restaurantId = this.$route.query.restaurantId;
            this.tableOrderInfo.tableName = this.$route.query.tableName;
            this.tableOrderInfo.orderType = this.$route.query.type;
            if (this.tableOrderInfo.orderType == 2) {
                this.tableOrderInfo.tableName = "0";
            }
            this.$refs.form.validate().then((result) => {
                if (result) {
                    let isSendSms = 1;
                    if (!this.chkSendSms) {
                        isSendSms = 2;
                    }
                    this.tableOrderInfo.isSendSms = isSendSms;
                    this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo, 7200000);
                    localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                    this.setTimeOut();
                    if (this.tableOrderInfo.orderType == 3) {
                        this.jumpBufft();
                    }
                    else if (this.tableOrderInfo.orderType == 2) {
                        this.$router.push({
                            path: '/takeaway', query: {}
                        })
                    }
                    else {
                        this.$router.push({
                            path: '/dinersNum', query: {}
                        })
                    }
                }
            });
        },
        setTimeOut() {
            window.localStorage.setItem('timeOut', formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'));
        },
        getTableOrderInfo() {
            var tableInfo = JSON.parse(localStorage.getItem('tableOrderInfo'));
            if (tableInfo != null && tableInfo != "" && this.$route.query.type != 2) {
                if (tableInfo.name == null || tableInfo.name == "") {
                    return;
                }
                if (tableInfo.telephone == null || tableInfo.telephone == "") {
                    return;
                }
                this.tableOrderInfo.name = tableInfo.name;
                this.tableOrderInfo.telephone = tableInfo.telephone;
                this.tableOrderInfo.orderType = tableInfo.orderType;
                if (this.tableOrderInfo.restaurantId != tableInfo.restaurantId) {
                    this.tableOrderInfo.number = 0;
                    this.tableOrderInfo.specielle = "";
                }
            }
            this.tableOrderInfo.restaurantId = this.$route.query.restaurantId;
            this.tableOrderInfo.orderType = this.$route.query.type;
            if (this.tableOrderInfo.orderType == 2) {
                this.tableOrderInfo.tableName = "0";
            }
            else {
                this.tableOrderInfo.tableName = this.$route.query.tableName;
            }
            if (this.tableOrderInfo.name != null && this.tableOrderInfo.name != "" && this.tableOrderInfo.name != "guest" && this.tableOrderInfo.telephone != null && this.tableOrderInfo.telephone != "") {
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo, 7200000);
                localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                this.setTimeOut();
                if (this.tableOrderInfo.orderType == 3) {
                    this.jumpBufft();
                }
                else if (this.tableOrderInfo.orderType == 2) {
                    return;
                }
                else {
                    this.$router.push({
                        path: '/dinersNum', query: {}
                    })
                }
            }
        },
        formatPhone(e) {
            let value = this.tableOrderInfo.telephone;
            value = value.replace(/^\+/, '');
            value = value.replace(/\D/g, '');
            this.tableOrderInfo.telephone = value;
        },
        timeOutCheck() {
            let that = this;
            var time = window.localStorage.getItem('timeOut');
            if (time != undefined && time != null && time != "") {
                var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                var now = new Date().getTime();
                var diffValue = now - dateTimeStamp;
                var minute = 1000 * 60;
                var minC = diffValue / minute;
                if (parseInt(minC) >= 120) {
                    this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                        type: 'warning', okLabel: this.$t("common.ok"),
                    }).then(function (result, value) {
                        that.$router.push({
                            path: '/error'
                        })
                    });
                    return false;
                }
                return true;
            }
            this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                type: 'warning', okLabel: this.$t("common.ok"),
            }).then(function (result, value) {
                that.$router.push({
                    path: '/error'
                })
            });
            return false;

        },
        jumpBufft() {
            if (!this.timeOutCheck()) {
                return;
            }
            this.billOpen = false;
            let param = {
                restaurantId: this.tableOrderInfo.restaurantId,
                tableName: this.tableOrderInfo.tableName
            };
            // 先确保配置已加载；单点模式（SingleService=1）无需校验套餐，直接进 Unavailable 页面
            this.ensureConfigs().then(() => {

                if (this.configsData.SingleService!=null && String(this.configsData.SingleService) === '1') {
                    this.$router.push({ path: '/unavailable', query: {} });
                    return;
                }
                this.checkBuffetPackageAndJump(param);
            });
        },
        checkBuffetPackageAndJump(param) {
            this.$get('QRCodeOrder/CheckIsBuffetPackage', param)
                .then(result => {
                    if (result.code == 200) {
                        let response = result.data;
                        if (response) {
                            this.$router.push({
                                path: '/buffet', query: {
                                    isSeft: 1, v: 20260811
                                }
                            })
                        }
                        else {
                            this.jumpAfterPackageCheck(param);
                        }
                    } else {
                        this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                    }
                });

        },
        // 无套餐数据时，根据 SelfCheckIn / RedirectOnClosedHours 决定进入 Unavailable 还是 BuffetSelect
        jumpAfterPackageCheck(param) {
            // 确保配置已加载（不触发 RequireLogin 自动下单逻辑，避免递归）
            this.ensureConfigs().then(() => {
                this.$get('QRCodeOrder/GetOrderBuffetPackage', param)
                    .then(result => {
                        if (result.code != 200) {
                            // 接口异常时保持原有流程，避免误拦用户
                            this.$router.push({ path: '/buffetSelect', query: {} });
                            return;
                        }
                        const list = result.data || [];
                        const hasPackage = list.some(item => (parseInt(item.quantity) || 0) > 0);
                        if (!hasPackage && this.needUnavailablePage()) {
                            this.$router.push({ path: '/unavailable', query: {} });
                            return;
                        }
                        this.$router.push({ path: '/buffetSelect', query: {} });
                    });
            });
        },
        // 仅加载配置，不触发任何跳转/下单副作用
        ensureConfigs() {
            if (!this.tableOrderInfo.restaurantId) return Promise.resolve();
            return this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        response.data.forEach(item => {
                            this.configsData[item.configKey] = item.configValue;
                        });
                    }
                });
        },
        // 两项配置都不为空且至少一项为 1 时进入 Unavailable；任意一项为 null 时保持 BuffetSelect
        needUnavailablePage() {
            const selfCheckIn = this.configsData.SelfCheckIn;
            const redirectOnClosedHours = this.configsData.RedirectOnClosedHours;
            if (selfCheckIn == null || selfCheckIn === '' || redirectOnClosedHours == null || redirectOnClosedHours === '') {
                return false;
            }
            return String(selfCheckIn) === '1' || String(redirectOnClosedHours) === '1';
        },
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (document.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    .login
        position: fixed
        top: 0
        bottom: 0
        width: 100%
        background: linear-gradient(160deg, #fff6f1 0%, #ffffff 55%, #fde8df 100%)
        display: flex
        flex-direction: column
        overflow: hidden
        &::before
            content: ''
            position: absolute
            top: -120px
            left: 50%
            transform: translateX(-50%)
            width: 480px
            height: 480px
            background: radial-gradient(circle, rgba(218,91,58,0.08) 0%, transparent 70%)
            pointer-events: none

    .top-bar
        position: absolute
        top: 12px
        right: 12px
        z-index: 1000
        display: flex
        align-items: center

        .lang-btn
            min-width: auto
            padding: 0 12px
            height: 32px
            line-height: 32px
            border-radius: 16px
            font-weight: 600
            font-size: 13px
            color: #da5b3a
            background: rgba(255,255,255,0.9)
            border: 1px solid rgba(218,91,58,0.25)
            box-shadow: 0 2px 8px rgba(218,91,58,0.08)
            text-transform: none

    .indexLogin
        flex: 1
        padding: 0 28px 32px
        display: flex
        flex-direction: column
        justify-content: center
        max-width: 440px
        margin: 0 auto
        width: 100%
        box-sizing: border-box

    .logo-wrap
        margin-bottom: 36px
        text-align: center

        .logo-frame
            display: inline-flex
            align-items: center
            justify-content: center
            margin: 0 auto
            padding: 18px 24px
            background: #fff
            border-radius: 20px
            box-shadow:
                0 4px 20px rgba(218,91,58,0.1),
                0 1px 3px rgba(0,0,0,0.04)
            transition: all .3s ease

        .logo-img
            display: block
            object-fit: contain
            transition: opacity .4s ease
            &::after
                content: ''
                position: absolute
                inset: 0
                background: #fff

        // 各形状适配：统一 object-fit: contain，让图片完整显示不变形
        .logo-frame.square
            width: 140px
            height: 140px
            padding: 0
            border-radius: 50%
            .logo-img
                width: 100%
                height: 100%
                border-radius: 50%

        .logo-frame.landscape
            width: 200px
            height: 120px
            padding: 14px 20px
            border-radius: 24px
            .logo-img
                max-width: 100%
                max-height: 80px

        .logo-frame.portrait
            width: 120px
            height: 160px
            padding: 14px 16px
            border-radius: 20px
            .logo-img
                max-width: 88px
                max-height: 130px

        .logo-frame.wide
            width: 260px
            height: 90px
            padding: 10px 22px
            border-radius: 16px
            .logo-img
                max-width: 100%
                max-height: 60px

        .logo-frame.tall
            width: 90px
            height: 200px
            padding: 12px 14px
            border-radius: 16px
            .logo-img
                max-width: 60px
                max-height: 160px

        .logo-frame.auto
            width: auto
            height: auto
            max-width: 240px
            .logo-img
                max-width: 200px
                max-height: 120px

    .restaurant-name
        min-height: 96px
        display: flex
        align-items: center
        justify-content: center
        text-align: center
        font-size: 22px
        font-weight: 700
        color: #333
        margin-bottom: 32px
        padding: 0 16px
        word-break: break-word

    .login-form
        width: 100%

    .sms-row
        margin-bottom: 16px

    .action-buttons
        margin-top: 16px
        display: flex
        flex-direction: column
        gap: 14px

        >>> .mu-form-item-content
            flex-direction: column
            gap: 14px

        >>> .mu-button
            margin: 0

        .btn-primary
            background: linear-gradient(135deg, #e8733a 0%, #da5b3a 100%)
            color: #fff
            border-radius: 26px
            height: 48px
            font-size: 16px
            font-weight: 600
            letter-spacing: 0.5px
            box-shadow: 0 6px 18px rgba(218,91,58,0.35)
            text-transform: none
            transition: transform .15s ease, box-shadow .15s ease
            &:active
                transform: scale(0.98)
                box-shadow: 0 3px 10px rgba(218,91,58,0.25)

        .btn-secondary
            background: #fff
            color: #da5b3a
            border: 1.5px solid rgba(218,91,58,0.35)
            border-radius: 26px
            height: 46px
            font-size: 15px
            font-weight: 500
            text-transform: none
            transition: background .15s ease
            &:active
                background: rgba(218,91,58,0.08)

    // mu-text-field 聚焦态微调
    /deep/ .mu-text-field.focused .mu-text-field-input
        border-color: #da5b3a

    /deep/ .mu-label.float
        color: #da5b3a !important
</style>



// WEBPACK FOOTER //
// src/components/Login.vue